import { render, staticRenderFns } from "./newStoreInfo.vue?vue&type=template&id=bf3c02d6&scoped=true&"
import script from "./newStoreInfo.vue?vue&type=script&lang=js&"
export * from "./newStoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./newStoreInfo.vue?vue&type=style&index=0&id=bf3c02d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3c02d6",
  null
  
)

export default component.exports